<template>
  <div>
    <el-container v-if="isLogin">
      <el-header>
        <el-menu class="el-menu-demo" mode="horizontal">
          <el-menu-item index="1"><img src="./assets/logo.png" style="width: 50px;">优企网站管理系统</el-menu-item>
          <el-menu-item index="3" v-if="displayUser">姓名：{{displayUser.name}}</el-menu-item>
          <el-menu-item index="3" v-if="displayUser">用户权限：{{displayUser.role}}</el-menu-item>
          <el-menu-item index="4" @click="logout">退出登录</el-menu-item>
        </el-menu>
        <div class="line"></div>
      </el-header>
      <el-container>
        <el-aside width="200px"><Aside></Aside></el-aside>
        <el-container>
          <el-main><router-view /></el-main>
        </el-container>
      </el-container>
    </el-container>
    <router-view v-if="!isLogin" />
  </div>
</template>

<script>
import Aside from './components/aside.vue';
export default {
  components: { Aside },
  name: 'App',
  data() {
    return {
      isLogin: false,
      userInfo:{},
      displayUser: null
    };
  },
  mounted() {
    let token = localStorage.getItem('token');
    if (!token) {
      this.isLogin = false;
      this.$router.push({
        path: '/user/login'
      });
    } else {
      this.isLogin = true;
    }
    this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
    let displayUser = this.userInfo && this.userInfo.userInfo ? this.userInfo.userInfo : this.userInfo
    if (displayUser) {
      this.displayUser = {
        name: displayUser.name == 'Administrator' ? '管理员' : displayUser.name,
        role: displayUser.role == 'Administrator' ? '管理员' : displayUser.role
      }
    }
  },
  methods:{
    logout(){
      localStorage.removeItem('token')
      location.reload()
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/App.vue